module.exports = __webpack_public_path__ + "assets/user_plus-c72ccf.svg";